var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.25L22.75 12.25C23.2332 12.25 23.625 11.8582 23.625 11.375L23.625 6.125C23.625 5.64175 23.2332 5.25 22.75 5.25L5.25 5.25C4.76675 5.25 4.375 5.64175 4.375 6.125L4.375 11.375C4.375 11.8582 4.76675 12.25 5.25 12.25Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 22.75L22.75 22.75C23.2332 22.75 23.625 22.3582 23.625 21.875L23.625 16.625C23.625 16.1418 23.2332 15.75 22.75 15.75L5.25 15.75C4.76675 15.75 4.375 16.1418 4.375 16.625L4.375 21.875C4.375 22.3582 4.76675 22.75 5.25 22.75Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 18.1562C7.70844 18.1562 7.21875 18.6459 7.21875 19.25C7.21875 19.8541 7.70844 20.3438 8.3125 20.3438C8.91656 20.3438 9.40625 19.8541 9.40625 19.25C9.40625 18.6459 8.91656 18.1562 8.3125 18.1562Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 7.65625C7.70844 7.65625 7.21875 8.14594 7.21875 8.75C7.21875 9.35406 7.70844 9.84375 8.3125 9.84375C8.91656 9.84375 9.40625 9.35406 9.40625 8.75C9.40625 8.14594 8.91656 7.65625 8.3125 7.65625Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/DeviceIcon.63a1586244c6d534b17810df304880b6.svg";
export { ForwardRef as ReactComponent };